import { useTranslation } from "react-i18next";
import { MediaControl } from "./MediaControl";
import { ConfigSection, MicrophoneDeviceSetting, ToggleSetting } from "./MediaSettings";
import { VoiceThresholdControl } from "./VoiceThresholdControl";
import { PopoverSeparator } from "../ui/popover";

export function MicrophoneControl() {
  const { t } = useTranslation();
  return (
    <MediaControl
      source="microphone"
      title={t("voice.settingsTitle")}
      description={t("voice.settingsDescription")}
    >
      <ConfigSection title={t("voice.inputTitle")} description={t("voice.inputDescription")}>
        <MicrophoneDeviceSetting />
        <VoiceThresholdControl />
      </ConfigSection>
      <PopoverSeparator />
      <ConfigSection
        title={t("voice.processingTitle")}
        description={t("voice.processingDescription")}
      >
        <ToggleSetting
          id="microphoneEchoCancellation"
          title={t("voice.echoCancellation")}
          description={t("voice.echoCancellationDescription")}
        />
        <ToggleSetting
          id="microphoneNoiseSuppression"
          title={t("voice.noiseSuppression")}
          description={t("voice.noiseSuppressionDescription")}
        />
        <ToggleSetting
          id="microphoneAutoGainControl"
          title={t("voice.autoGainControl")}
          description={t("voice.autoGainControlDescription")}
        />
      </ConfigSection>
    </MediaControl>
  );
}
